import { post, url, get, postJson } from '../../service/ApiDecorator'
// 学生成长-页面组件-学生成绩档案配置
class SemesterGrades {
  // 查询主观打分数据源-支持的场景-任务-字段列表
  @url('/develop/custom/gradetype/pageDateSourceItem')
  @get
  pageDateSourceItem() { }

  // 根据学科获取学生成绩档案页面组件配置
  @url('/develop/custom/gradetype/listGradeTypeBySubjectCode')
  @get
  listGradeTypeBySubjectCode() { }

  // 根据学科获取所有年级考试
  @url('/develop/custom/gradetype/listExamBySubjectCode')
  @get
  listExamBySubjectCode() { }

  // 修改学生成绩档案页面组件配置状态
  @url('/develop/custom/gradetype/updateGradeTypeState')
  @get
  updateGradeTypeState() { }

  // 根据学科Code删除学生成绩档案配置
  @url('/develop/custom/gradetype/delGradeTypeBySubjectCode')
  @post
  delGradeTypeBySubjectCode() { }

  // 根据ID删除学生成绩档案配置
  @url('/develop/custom/gradetype/delGradeTypeByIds')
  @post
  delGradeTypeByIds() { }

  // 新建或修改学生成绩档案配置
  @url('/develop/custom/gradetype/addOrUpdateGradeType')
  @postJson
  addOrUpdateGradeType() { }

  // 重新初始化
  @url('/develop/custom/gradetype/reSyncGradeType')
  @post
  reSyncGradeType() { }

  // 查询学生等第数据
  @url('/develop/custom/gradetype/getStuGradeTypeByStuId')
  @get
  getStuGradeTypeByStuId() { }

  // 查询已保存的科目编码
  @url('/develop/custom/gradetype/listAllSubjectCode')
  @get
  listAllSubjectCode() { }

  // 分页查询学生所有学科的等第值
  @url('/develop/custom/gradetype/pageAllSubjectGradeTypeVal')
  @get
  pageAllSubjectGradeTypeVal() { }

  // 全量导出
  @url('/develop/custom/gradetype/exportStuGradeType')
  @post
  exportStuGradeType() { }

  // 按年级导出
  @url('/develop/custom/gradetype/exportStuGradeTypeByGrade')
  @post
  exportStuGradeTypeByGrade() { }
}
export default new SemesterGrades()
